// extracted by mini-css-extract-plugin
export default {"link":"PreApprovalImportPanel_link__PnFK-"};